import React from "react";
import { Link } from "react-router-dom";

import styles from "./VerifyAccountBanner.scss";

class VerifyAccountBanner extends React.Component {
  render() {
    const isCompanyProjectIndex = window.location.href.includes(
      "/company/projects"
    );
    const isVerified = localStorage.getItem("verified") !== "false";

    return (
      <div className={styles.verifyAccountBannerContainer}>
        {!isVerified && isCompanyProjectIndex && (
          <div className={styles.verifyAccountBanner}>
            <div className={styles.verifyAccountBannerContent}>
              <div className={styles.textContainer}>
                <p className={styles.title}>Meet your Match(es)</p>
                <p className={styles.text}>
                  Before you can submit your first project for approval, we need
                  to verify your account. Click “Verify” to complete this
                  process.
                </p>
              </div>
              <div className={styles.buttonContainer}>
                <Link to="/company/verify-account" className={styles.button}>
                  VERIFY
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default VerifyAccountBanner;



// WEBPACK FOOTER //
// ./src/components/common/verifyAccountBanner/VerifyAccountBanner.js